/* Gunnaro — extras.js
   1) Open/closed status from Theme settings → Otevírací doba (Europe/Prague time)
   2) Wishlist (Oblíbené) and 3) Recently viewed — stored only in the visitor's browser (localStorage).
   Cards are fetched from /products/{handle}?view=card (templates/product.card.liquid). */
(() => {
  const G = (window.Gunnaro = window.Gunnaro || {});
  const S = G.strings || {};
  const store = {
    get(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch { return []; } },
    set(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* private mode */ } },
  };

  /* ---------- 1) Open / closed ---------- */
  const DAYS = ['pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota', 'neděle'];
  const DAYS_ACC = ['v pondělí', 'v úterý', 've středu', 've čtvrtek', 'v pátek', 'v sobotu', 'v neděli'];

  function parseHours(raw) {
    const week = Array.from({ length: 7 }, () => null); // index 0 = Monday
    String(raw || '').split(/\r?\n/).forEach((line) => {
      const [dayPart, timePart] = line.split('|').map((x) => (x || '').trim().toLowerCase());
      if (!dayPart || !timePart) return;
      const found = DAYS.map((d, i) => (dayPart.includes(d) ? i : -1)).filter((i) => i >= 0);
      if (!found.length) return;
      const from = Math.min(...found);
      const to = Math.max(...found);
      const m = timePart.match(/(\d{1,2})[:.](\d{2})\s*[–—-]\s*(\d{1,2})[:.](\d{2})/);
      for (let d = from; d <= to; d++) week[d] = m ? { open: +m[1] * 60 + +m[2], close: +m[3] * 60 + +m[4], openText: `${m[1]}:${m[2]}`, closeText: `${m[3]}:${m[4]}` } : null;
    });
    return week;
  }

  function pragueNow() {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Prague', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    const get = (t) => parts.find((p) => p.type === t)?.value;
    const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(get('weekday'));
    return { day, minutes: (+get('hour') % 24) * 60 + +get('minute') };
  }

  function openStatus() {
    const el = document.getElementById('StoreHoursData');
    if (!el) return null;
    // Czech preposition before a clock time: „ve“ where the spoken number starts with a consonant cluster
    // (dvě, tři, čtyři, dvanáct, čtrnáct, dvacet…) → „ve 12:00“, otherwise „v 10:00“
    const at = (text, time) => {
      const h = parseInt(time, 10);
      const ve = [2, 3, 4, 12, 14, 20, 21, 22, 23].includes(h);
      return text.replace(/v \{time\}/, (ve ? 've ' : 'v ') + '{time}').replace('{time}', time);
    };
    const week = parseHours(JSON.parse(el.textContent));
    if (!week.some(Boolean)) return null;
    const { day, minutes } = pragueNow();
    const today = week[day];
    if (today && minutes >= today.open && minutes < today.close) {
      return { open: true, text: (S.openNow || 'Otevřeno · dnes do {time}').replace('{time}', today.closeText) };
    }
    if (today && minutes < today.open) {
      return { open: false, text: at(S.closedToday || 'Zavřeno · otevíráme dnes v {time}', today.openText) };
    }
    for (let i = 1; i <= 7; i++) {
      const d = (day + i) % 7;
      if (week[d]) {
        const when = i === 1 ? (S.tomorrow || 'zítra') : DAYS_ACC[d];
        return { open: false, text: at((S.closedNext || 'Zavřeno · otevíráme {day} v {time}').replace('{day}', when), week[d].openText) };
      }
    }
    return null;
  }

  function renderOpenStatus() {
    const st = openStatus();
    document.querySelectorAll('[data-open-status]').forEach((el) => {
      if (!st) { el.hidden = true; return; }
      el.textContent = st.text;
      el.classList.toggle('is-open', st.open);
      el.classList.toggle('is-closed', !st.open);
      el.hidden = false;
    });
  }
  renderOpenStatus();
  setInterval(renderOpenStatus, 60 * 1000);

  /* ---------- helpers: product cards ---------- */
  const cardCache = new Map();
  const HANDLE = /^[\p{L}\p{N}_-]+$/u; // Shopify handles: letters, digits, "-" and "_" only
  async function fetchCard(handle) {
    if (typeof handle !== 'string' || !HANDLE.test(handle)) return '';
    if (cardCache.has(handle)) return cardCache.get(handle);
    const p = fetch(`${G.routes.root}products/${encodeURIComponent(handle)}?view=card`.replace('//products', '/products'))
      .then((r) => (r.ok ? r.text() : ''))
      .then((html) => (/^\s*<article class="card[\s"]/.test(html) ? html : ''))
      .catch(() => '');
    cardCache.set(handle, p);
    return p;
  }
  async function renderCards(list, handles) {
    const htmls = await Promise.all(handles.map(fetchCard));
    list.innerHTML = htmls.filter(Boolean).map((h) => `<li>${h}</li>`).join('');
    syncWishlistButtons(list);
    return list.children.length;
  }

  /* ---------- 2) Wishlist ---------- */
  const WKEY = 'gn:wishlist';
  const wishlist = () => store.get(WKEY);

  function syncWishlistButtons(root = document) {
    const set = new Set(wishlist());
    root.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
      const on = set.has(btn.dataset.wishlistToggle);
      btn.setAttribute('aria-pressed', String(on));
      btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
    });
    const count = set.size;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = count || ''; el.dataset.count = count; });
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    const handle = btn.dataset.wishlistToggle;
    const list = wishlist();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1); else list.unshift(handle);
    store.set(WKEY, list.slice(0, 60));
    syncWishlistButtons();
    G.toast?.(i >= 0 ? S.wishlistRemoved : S.wishlistAdded);
    if (i >= 0) renderWishlistPage();
  });

  async function renderWishlistPage() {
    const page = document.querySelector('[data-wishlist-page]');
    if (!page) return;
    const list = page.querySelector('[data-wishlist-list]');
    const n = await renderCards(list, wishlist());
    page.querySelector('[data-wishlist-empty]').hidden = n > 0;
  }

  /* ---------- 3) Recently viewed ----------
     Stored only with consent to personalisation cookies (Shopify cookie banner, "preferences");
     the visitor did not ask for this list, so it is not strictly necessary storage. */
  const RKEY = 'gn:recent';
  const track = document.querySelector('[data-recent-track]');
  const prefsAllowed = () => { try { return !!window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.(); } catch (e) { return false; } };
  const withPrivacy = (cb) => {
    if (window.Shopify?.customerPrivacy) return cb();
    if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => cb(err));
    else cb(true);
  };
  const recordRecent = () => {
    if (!track) return;
    const h = track.dataset.recentTrack;
    store.set(RKEY, [h, ...store.get(RKEY).filter((x) => x !== h)].slice(0, 12));
  };
  const dropRecent = () => { try { localStorage.removeItem(RKEY); } catch (e) { /* storage blocked */ } };
  document.addEventListener('visitorConsentCollected', (e) => {
    if (e.detail?.preferencesAllowed) { recordRecent(); renderRecent(); } else dropRecent();
  });

  async function renderRecent() {
    const sec = document.querySelector('[data-recently-viewed]');
    if (!sec || !prefsAllowed()) return;
    const exclude = sec.dataset.exclude;
    const handles = store.get(RKEY).filter((h) => h && h !== exclude).slice(0, Number(sec.dataset.limit) || 4);
    if (!handles.length) return;
    const list = sec.querySelector('[data-recently-list]');
    const n = await renderCards(list, handles);
    list.style.setProperty('--grid-cols', Math.max(1, Math.min(n, 4))); // max 4 per row, fewer items → wider cards
    sec.hidden = n === 0;
    sec.querySelector('[data-recently-clear]')?.addEventListener('click', () => { store.set(RKEY, []); sec.hidden = true; });
  }

  syncWishlistButtons();
  renderWishlistPage();
  // defer non-critical work until the browser is idle
  (window.requestIdleCallback || ((fn) => setTimeout(fn, 300)))(() => withPrivacy(() => {
    if (prefsAllowed()) { recordRecent(); renderRecent(); } else dropRecent();
  }));
})();
